module.exports = __webpack_public_path__ + "18615492d1edc844b8e1e1b7b1da6bc1.svg";